import React from "react";
import normalCurve from '../images/Gaussian_distribution.png';
import pdf from '../media/MADRS.pdf';

function IntroductionPage(props) {

	return (
		<div className="introduction-wrapper">
			<div className="white-background">
				<main>
					<div className="blue-background">
						<div className="flex-wrapper">
							<div className="flex-left">
								<h1 className="heading-big">Samskattningsutbildning MADRS</h1>
								<p>
									Syftet med den här utbildningen är att du ska öva dig på att skatta symtom på depression med MADRS. Målet är att dina skattningar ska överensstämma med andra medarbetares skattningar. Detta är viktigt för att dina medarbetare ska kunna lita på de bedömningar du gör, och för att patienterna ska få rätt vård.
								</p>
								<p>Utbildningen går till så att du kommer se på en inspelad MADRS intervju med en låtsaspatient. Du ska skatta patientens symtom på depression med hjälp av MADRS. Ditt resultat (både summan och svaret på respektive fråga) jämförs sedan med alla tidigare kursdeltagares resultat, och du får se hur dina svar avviker från de andras. Om du avviker för mycket, mer än två standarddeviationer, får du inte godkänt.</p>
								<p>Utbildningen tar cirka en kvart. Du kan upprepa den så många gånger du vill. Bara ditt senaste resultat sparas. Avslutningsvis skriver du ut/sparar ned det diplom som du erhåller som bevis på genomförd godkänd utbildning. Visa upp det för din närmaste chef.</p>
							</div>
							<div className="flex-right">
								<div className="img-wrapper">
									<img className="intro-img" src={normalCurve} alt="En exempelbild av en normalfördelningskurva" />
								</div>
							</div>
						</div>
					</div>

					<hr />

					<div className="instructions-wrapper">
						<div className="instructions-text">
							<h2 className="heading-medium">Instruktioner</h2>
							<p>
								Du kan välja på att direkt fylla i MADRS digitalt efter att ha sett filmen, eller att först skriva ut skattningsformuläret, fylla i det medan du ser på filmen och därefter föra in din skattning i det digitala MADRS-formuläret.
								Vi rekommenderar det senare. Dina svar kommer sedan att visas jämförda med andras svar, både totalpoängen och svaren på respektive fråga.
							</p>
							<p>Testet är inte tidsbegränsat och du kan se om filmen så många gånger du vill. Du kan även göra om testet. Bara ditt senaste resultat sparas.</p>
							<br/>
							<a href={pdf} target="_blank">Klicka här för att skriva ut skattningsformuläret (pdf).</a>
						</div>
					</div>

					<nav className="btn-wrapper">
						<div className="btn-center-wrapper">
							<button className="btn btn-next" onClick={() => props.setStarted(true)}>
								Starta
		</button>
						</div>
					</nav>

				</main>

				<div className="pink-circle"></div>
			</div>
		</div>
	);
}

export default IntroductionPage;



// WEBPACK FOOTER //
// ./src/pages/IntroductionPage.js